import { W as WuiDateRangeInputWithPresets$1, d as defineCustomElement$1 } from './p-BTQUPCEP.js';

const WuiDateRangeInputWithPresets = WuiDateRangeInputWithPresets$1;
const defineCustomElement = defineCustomElement$1;

export { WuiDateRangeInputWithPresets, defineCustomElement };
